import { render, staticRenderFns } from "./CheckoutBasket.vue?vue&type=template&id=b6fc493c&scoped=true"
import script from "./CheckoutBasket.vue?vue&type=script&lang=js"
export * from "./CheckoutBasket.vue?vue&type=script&lang=js"
import style0 from "./CheckoutBasket.vue?vue&type=style&index=0&id=b6fc493c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fc493c",
  null
  
)

export default component.exports